module.exports = __webpack_public_path__ + "static/media/how_we_protect.47b15dda.jpg";